export const extractMetaTagContent = (
  doc: Document,
  metaAttributeValue: string,
): string | null => {
  const metaTag = doc.querySelector(
    `meta[property="${metaAttributeValue}"], meta[name="${metaAttributeValue}"]`,
  );
  return metaTag ? metaTag.getAttribute('content') : null;
};
